module.exports = __webpack_public_path__ + "img/img-apple-store-download.cc35be41.jpg";